/*
  Close control for the cart drawer's title bar.

  The theme's own <close-cart> binds with document.querySelector('.js-close-header-cart'),
  so it wires up exactly one button — the one already in the header row. A second
  button with that class would never bind. This dispatches the same cart:close
  event the theme listens for, so the drawer closes through its normal path.

  Delegated at the document level because the drawer's contents are re-rendered
  on every cart update, which discards directly-bound listeners.
*/
(function () {
  if (window.__originsCartBound) return;
  window.__originsCartBound = true;

  /*
    Remove, in the drawer.

    The theme renders Remove as a plain <a> pointing at
    /cart/change?id=…&quantity=0, which answers 302 and lands the shopper on
    /cart. That is why the theme hides the link inside the drawer — it is the
    no-JS fallback, not a drawer control. Since the link is now shown, it is
    intercepted here and run through cart/change.js instead, asking for the
    cart-ajax section back and handing it to the drawer through the same
    ajaxProduct:added event the quick-add uses. preventCartOpen is set because
    the drawer is already open.

    If the request fails the original href is followed, so the item still comes
    out of the cart the slow way rather than the click doing nothing.
  */
  /*
    Add to cart: open the drawer immediately.

    The theme's own handler still does the work — this only brings the drawer
    forward so the panel is already sliding while the request is in flight,
    instead of nothing happening for the ~600ms the round trip takes. The new
    line lands as the response arrives, largely inside the open animation.

    Deliberately no optimistic count or subtotal here. We do not see the
    response (the theme owns it), so a rejected add — out of stock, a quantity
    limit — would leave a number we could not correct. Opening early is free;
    guessing at totals is not.
  */
  /*
    Add to cart, optimistically.

    Opening the drawer early helped, but the line itself still waited on the
    round trip. To place it immediately we have to own the request: the theme's
    handler alerts on a rejected add (out of stock, quantity cap) without
    emitting any event, so shadowing it would leave a row we could never
    retract. Intercepting in the capture phase and stopping propagation means
    exactly one request is sent, by us, and we see how it ends.

    Only single-variant buttons are taken over. Multi-variant products open the
    theme's variant picker and are left alone.

    The placeholder is built from what is already on the card — image, title,
    price — and is replaced wholesale when the authoritative cart-ajax markup
    arrives. It is marked data-origins-optimistic so a failure can pull out
    precisely the row we added and nothing else.
  */
  /*
    The drawer's title-bar count is ours, not the theme's. CartForm.cartMarkup
    refreshes the item list, subtotal, discounts and the theme's own header, but
    knows nothing about this element, so it went stale after every add. Read the
    authoritative number off the returned markup — .cart__items carries
    data-count="{{ cart.item_count }}" — rather than trusting a local tally.
  */
  function syncCount(sectionHtml) {
    var el = document.querySelector('[data-cart-count]');
    if (!el || !sectionHtml) return;
    try {
      var items = new DOMParser()
        .parseFromString(sectionHtml, 'text/html')
        .querySelector('.cart__items');
      if (items && items.dataset.count !== undefined) el.textContent = items.dataset.count;
    } catch (err) { /* leave the existing number rather than guess */ }
  }

  /*
    Quantity steppers: keep the title-bar count in step.

    The theme's quantityChanged posts to cart/change.js and hands the result to
    CartForm.cartMarkup, which — as with add — never touches this element, so
    the count sat still while the line quantity moved. cart:updated carries the
    whole cart, so the authoritative figure is taken from there.

    The count is also nudged on click so it moves with the number the shopper
    just pressed rather than lagging the round trip. That nudge is a guess, so
    it is always overwritten by cart:updated, and if no response arrives within
    five seconds the real cart is fetched and the guess discarded — a rejected
    change (an inventory cap) resets the input without telling us, and a count
    left reading one too many is worse than a slow one.
  */
  var countFallback = null;

  /*
    Every add path, not just the product cards.

    The header badge is already handled: toggle-cart listens for
    ajaxProduct:added and cart:updated and rewrites .cart-link__bubble from the
    returned section. The drawer's title-bar count is ours, so it has to listen
    for the same events — otherwise it only kept up with adds we intercept
    ourselves and drifted on product-page and quick-shop adds.
  */
  /*
    Feedback, now that the drawer no longer opens by itself.

    The card button says "Added" for a moment, and the header cart pulses on
    any add — including the product page and quick shop, which we do not own —
    because that listener sees every path.
  */
  function flashCart() {
    var link = document.querySelector('.cart-link');
    if (!link) return;
    link.classList.remove('origins-cart-flash');
    void link.offsetWidth;
    link.classList.add('origins-cart-flash');
    setTimeout(function () { link.classList.remove('origins-cart-flash'); }, 700);
  }

  function confirmOn(btn) {
    if (!btn) return;
    var label = btn.querySelector('.icon__fallback-text');
    if (!label || btn.dataset.originsConfirming) return;
    btn.dataset.originsConfirming = '1';
    var was = label.textContent;
    label.textContent = 'Added';
    btn.classList.add('is-added');
    setTimeout(function () {
      label.textContent = was;
      btn.classList.remove('is-added');
      delete btn.dataset.originsConfirming;
    }, 1400);
  }

  document.addEventListener('ajaxProduct:added', function (e) {
    flashCart();
    if (countFallback) { clearTimeout(countFallback); countFallback = null; }
    var p = e.detail && e.detail.product;
    if (p && p.sections && p.sections['cart-ajax']) syncCount(p.sections['cart-ajax']);
  });

  document.addEventListener('cart:updated', function (e) {
    if (countFallback) { clearTimeout(countFallback); countFallback = null; }
    var cart = e.detail && e.detail.cart;
    if (!cart) return;
    if (cart.sections && cart.sections['cart-ajax']) {
      syncCount(cart.sections['cart-ajax']);
    } else if (typeof cart.item_count === 'number') {
      var el = document.querySelector('[data-cart-count]');
      if (el) el.textContent = cart.item_count;
    }
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('.cart-drawer .element-quantity-selector__button');
    if (!step) return;
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    var delta = step.classList.contains('element-quantity-selector__button--minus') ? -1 : 1;
    el.textContent = Math.max(0, (parseInt(el.textContent, 10) || 0) + delta);

    if (countFallback) clearTimeout(countFallback);
    countFallback = setTimeout(function () {
      fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var c = document.querySelector('[data-cart-count]');
          if (c && typeof cart.item_count === 'number') c.textContent = cart.item_count;
        })
        .catch(function () { /* leave the number rather than replace it with a guess */ });
    }, 5000);
  });

  function optimisticRow(card, id) {
    var img = card.querySelector('.grid-product__image-wrap img');
    var title = card.querySelector('.grid-item__meta .element-text--body-md');
    var price = card.querySelector('.grid-item__meta .element-price');
    var row = document.createElement('div');
    row.className = 'cart__item';
    row.setAttribute('data-origins-optimistic', id);
    row.innerHTML =
      '<div class="cart__image"><span class="image-wrap">' +
        (img ? '<img src="' + img.currentSrc + '" alt="">' : '') +
      '</span></div>' +
      '<div class="cart__item-title"><span class="cart__item-name">' +
        (title ? title.textContent.trim() : '') +
      '</span></div>' +
      '<div class="cart__item-price text-right"><span class="cart__price">' +
        (price ? price.innerHTML : '') +
      '</span></div>';
    return row;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-grid-item .quick-add-btn');
    if (!btn || !btn.hasAttribute('data-single-variant-quick-add')) return;
    var id = btn.dataset.id;
    if (!id) return;

    e.preventDefault();
    e.stopPropagation();

    var loading = btn.querySelector('.btn');
    if (loading) loading.classList.add('btn--loading');

    // Only place a row when there is a list to place it in. An empty cart
    // hides the whole form, so the row would be invisible anyway.
    var drawer = document.querySelector('.cart-drawer');
    var list = drawer && !drawer.classList.contains('is-empty')
      ? drawer.querySelector('.cart__items')
      : null;
    var ghost = null;
    if (list) {
      ghost = optimisticRow(btn.closest('.product-grid-item'), id);
      list.insertBefore(ghost, list.firstChild);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-ajax'] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (loading) loading.classList.remove('btn--loading');
        if (!res.ok || !res.data || !res.data.sections || !res.data.sections['cart-ajax']) {
          if (ghost) ghost.remove();
          if (res.data && res.data.description) alert(res.data.description);
          return;
        }
        // Authoritative markup replaces everything, ghost included.
        syncCount(res.data.sections['cart-ajax']);
        confirmOn(btn);
        document.body.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: res.data, preventCartOpen: true }
        }));
      })
      .catch(function () {
        if (loading) loading.classList.remove('btn--loading');
        if (ghost) ghost.remove();
      });
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cart-drawer .cart__item-remove a');
    if (!link) return;
    e.preventDefault();

    var id = new URL(link.href, window.location.origin).searchParams.get('id');
    if (!id) return;

    // Optimistic: take the row out now. The request still runs, and the
    // authoritative markup from cart-ajax replaces everything on success, so
    // this only ever gets ahead of the server by the length of the round trip.
    var row = link.closest('.cart__item');
    var qty = 0;
    if (row) {
      var input = row.querySelector('.element-quantity-selector__input');
      qty = input ? parseInt(input.value, 10) || 0 : 0;
      row.dataset.originsPendingRemove = '1';
      row.style.display = 'none';
    }
    var countEl = document.querySelector('[data-cart-count]');
    var prevCount = countEl ? countEl.textContent : null;
    if (countEl && qty) {
      countEl.textContent = Math.max(0, (parseInt(prevCount, 10) || 0) - qty);
    }

    // Rollback is a straight restore of what we just changed — no attempt to
    // reconstruct cart state, which is where optimistic UI usually goes wrong.
    var rollback = function () {
      if (row) {
        row.style.display = '';
        delete row.dataset.originsPendingRemove;
      }
      if (countEl && prevCount !== null) countEl.textContent = prevCount;
    };

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 0, sections: ['cart-ajax'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.sections || !data.sections['cart-ajax']) {
          rollback();
          return;
        }
        document.body.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data, preventCartOpen: true }
        }));
        syncCount(data.sections['cart-ajax']);
      })
      .catch(function () {
        rollback();
        window.location.href = link.href;
      });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-origins-cart-close]');
    if (!btn) return;
    e.preventDefault();
    // Dispatched from <body>, not from the button. header-drawer.close() opens
    // with "do not close if the click came from inside the drawer" and bails
    // when evt.target.closest('.site-header__drawer') matches — a guard that
    // stops a click inside the panel dismissing it. Our button lives inside
    // that panel, so an event targeted at it was thrown away every time. The
    // theme's own close button escapes this only because it sits out in the
    // header. Retargeting to body clears the guard and closes through the
    // theme's normal path.
    document.body.dispatchEvent(new CustomEvent('cart:close', { bubbles: true }));
  });
})();
